import React, { useState, useEffect, useRef, useCallback } from 'react';
import EnergyTree from '../components/EnergyTree';
import { useWebSocket } from '../hooks/useWebSocket';

const TreeScreen = () => {
  const [currentCount, setCurrentCount] = useState(0);
  const [teslaTriggered, setTeslaTriggered] = useState(false);
  const [teslaCompleted, setTeslaCompleted] = useState(false);
  const [superGlowActive, setSuperGlowActive] = useState(false);
  const audioRef = useRef(null);
  const { lastMessage } = useWebSocket();

  // Handle WebSocket messages
  useEffect(() => {
    if (!lastMessage) return;

    if (lastMessage.type === 'tree_update') {
      setCurrentCount(lastMessage.current_count);
      
      // Auto-trigger Tesla at 280+
      if (lastMessage.current_count >= 280 && !teslaTriggered) {
        setTeslaTriggered(true);
      }
    } else if (lastMessage.type === 'tesla_trigger') {
      setTeslaTriggered(true);
    } else if (lastMessage.type === 'super_glow') {
      setSuperGlowActive(lastMessage.active);
    } else if (lastMessage.type === 'tree_reset') {
      setCurrentCount(0);
      setTeslaTriggered(false);
      setTeslaCompleted(false);
      setSuperGlowActive(false);
    } else if (lastMessage.type === 'init' && lastMessage.tree) {
      setCurrentCount(lastMessage.tree.current_count || 0);
      setTeslaTriggered(lastMessage.tree.tesla_triggered || false);
      setSuperGlowActive(lastMessage.tree.super_glow_active || false);
    }
  }, [lastMessage, teslaTriggered]);

  // Play Tesla sound
  useEffect(() => {
    if (teslaTriggered && !teslaCompleted) {
      const timeout = setTimeout(() => {
        if (audioRef.current) {
          audioRef.current.play().catch(e => console.log('Audio play failed:', e));
        }
      }, 2500);
      return () => clearTimeout(timeout);
    }
  }, [teslaTriggered, teslaCompleted]);

  const handleTeslaComplete = useCallback(() => {
    setTeslaCompleted(true);
  }, []);

  return (
    <div className="fullscreen" data-testid="tree-screen">
      <div className="wave-background" />
      
      <EnergyTree 
        currentCount={currentCount}
        teslaTriggered={teslaTriggered}
        superGlowActive={superGlowActive}
        onTeslaComplete={handleTeslaComplete}
      />

      {/* No stats panel - cinematic view only */}

      {/* Audio element */}
      <audio ref={audioRef} src="/assets/tesla.mp3" preload="auto" />
    </div>
  );
};

export default TreeScreen;
